import {InjectionToken} from '@angular/core';

export interface AppConfig {
  baseUrl: string;
  powerBiUrl: string;
  auth: {
    issuer: string;
    clientId: string;
    scope: string;
    redirectUri: string;
    responseType: string;
    showDebugInformation: boolean;
    strictDiscoveryDocumentValidation: boolean;
    preserveRequestedRoute: boolean;
  };
  reportUrls: {}
}

export const APP_CONFIG = new InjectionToken<AppConfig>('App configuration');
